import { booleanOptionIconLabels } from "@/constant/GeneralOptions/boolean";
import { featureStatusIconLabels } from "@/constant/GeneralOptions/feature-status";

export const columns = () => {
  const booleanOptionLabelsMap = booleanOptionIconLabels();

  return [
    {
      accessorKey: "order",
      header: "Order",
      size: 60,
      cell: ({ row }) => (
        <div className={"flex justify-center"}>{row.getValue("order")}</div>
      ),
    },
    {
      accessorKey: "region",
      header: "Region",
    },
    {
      accessorKey: "country.name",
      header: "Country/State",
      cell: ({ row }) => (
        <div className="flex gap-2 items-center">
          <div className="flex w-8">
            <img src={row.original.country?.icon_url} alt="icon" />
          </div>
          <div>{row.original.country.name}</div>
        </div>
      ),
    },
    {
      accessorKey: "customs_region",
      header: "Customs Region",
    },
    {
      accessorKey: "country.phone_code",
      header: "Phone Code",
    },
    {
      accessorKey: "country.tld",
      header: "TLD",
    },
    {
      id: "tld_owned",
      accessorFn: (row) => booleanOptionLabelsMap[row.tld_owned],
      header: "TLD Owned",
      cell: ({ getValue }) => <div className={"flex justify-center"}>{getValue()}</div>,
    },
    {
      accessorKey: "country.code",
      header: "Code 2",
    },
    {
      accessorKey: "country.code_alpha_3",
      header: "Code 3",
    },
    {
      id: "enable_professional_user",
      accessorFn: (row) => featureStatusIconLabels[row.enable_professional_user],
      header: "Commercial User",
      cell: ({ getValue }) => <div className={"flex justify-center"}>{getValue()}</div>,
    },
    {
      id: "enable_personal_user",
      accessorFn: (row) => featureStatusIconLabels[row.enable_personal_user],
      header: "Personal User",
      cell: ({ getValue }) => <div className={"flex justify-center"}>{getValue()}</div>,
    },
    {
      id: "vat_merchandise",
      accessorFn: (row) => `${row.vat_merchandise}%`,
      header: "VAT Merchandise",
    },
    {
      id: "vat_e_service",
      accessorFn: (row) => `${row.vat_e_service}%`,
      header: "VAT E-Service",
    },
    {
      id: "ship_to_location.code",
      accessorFn: (row) =>
        row.ship_to_location &&
        `${row.ship_to_location.code} - ${row.ship_to_location.name}`,
      header: "Ship-to Location",
    },
    {
      id: "language.code",
      accessorFn: (row) =>
        row.language && `${row.language.code} - ${row.language.title}`,
      header: "Language",
    },
    {
      id: "currency.code",
      accessorFn: (row) =>
        row.currency && `${row.currency.code} - ${row.currency.name}`,
      header: "Currency",
    },
  ];
};
